import { render, staticRenderFns } from "./DailyWeatherWidget.vue?vue&type=template&id=2384b4cc&scoped=true&"
import script from "./DailyWeatherWidget.vue?vue&type=script&lang=ts&"
export * from "./DailyWeatherWidget.vue?vue&type=script&lang=ts&"
import style0 from "./DailyWeatherWidget.vue?vue&type=style&index=0&id=2384b4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384b4cc",
  null
  
)

export default component.exports